// Static HTML site served from /app/frontend/public/index.html.
// React renders nothing so the original tascai HTML remains untouched.
function App() {
  return null;
}

export default App;
